import type { Order } from "../../api/types";
import { useTill } from "../../app/till-context";
import { t } from "../../i18n";
import { Dialog } from "../../ui/Dialog";
import { Receipt } from "./Receipt";
import { receiptPaper } from "./ReceiptDialog";

interface Props {
  orders: Order[];
  onClose: () => void;
}

/**
 * "🖨 Afdrukken" for several orders in a shop without a receipt printer (Beheer › Printers & toestellen):
 * "Afdrukken" prints them from the browser, each on its own page. With a receipt printer the Tafo app
 * for Windows prints them there (blok I).
 */
export function ReceiptsDialog({ orders, onClose }: Props) {
  const { status, general } = useTill();
  const text = t.orders.receipts;
  return (
    <Dialog
      title={text.title(orders.length)}
      onClose={onClose}
      footer={
        <>
          <span className="spacer" />
          <button type="button" className="btn" onClick={() => window.print()}>
            🖨 {t.orders.print}
          </button>
          <button type="button" className="btn primary" data-autofocus onClick={onClose}>
            OK
          </button>
        </>
      }
    >
      <p className="note">{text.note}</p>
      <div className="zbonpanel receipts">
        {orders.map((order) => (
          <Receipt
            key={order.id}
            order={order}
            shop={status.shop}
            general={general}
            paper={receiptPaper(status.device.type)}
          />
        ))}
      </div>
    </Dialog>
  );
}
